<template>
	<div class="body">
		<Header></Header>
		<div class="block">
			<div class="banner_news"></div>
			<div class="menu_block">
				<div class="content fsb">
					<div class="location">
						当前位置：
						<a href="/">首页</a>
						<i class="icon el-icon-arrow-right"></i>
						<a href="">新闻中心</a>
						<i class="icon el-icon-arrow-right"></i>
						<a href="">公司新闻</a>
					</div>
				</div>
			</div>

			<div class="content">
				<div class="news_detail">
					<div class="title">
						<strong>中喆德元电机云平台上线</strong>
						<span>发布日期：2023年5月20日</span>
					</div>
					<div class="text" style="text-align: center">
						<p style="text-align: left;font-size: 32px;line-height: 40px;">单位产能电机能耗详细分析</p>
						<p style="text-align: left;line-height: 60px;">分析企业各车间电机能耗：分析每个工艺生产车间每日能耗情况，根据分析对比判断能耗突变情况。</p>
						<p style="text-align: left;line-height: 60px;">分析企业每个工序电机能耗:，有助于分析是否因原材料、设备本体、管路洁净等情况导致能耗变动。</p>
						<p style="text-align: left;line-height: 60px;">分析企业每台电机每小时能耗:有助于分析设备本体是否存在潜在故障，或管路故障等。</p>
						<p><img src="../images/news/dianjiyun1.png" alt=""/></p>
						<p><img src="../images/news/dianjiyun2.png" alt=""/></p>
						<p><img src="../images/news/dianjiyun3.png" alt=""/></p>
                        <p style="text-align: left;font-size: 32px;line-height: 60px;">电机运维服务功能</p>
                        <p style="text-align: left;line-height: 60px;">实时数据采集：分析每台电机运行数据，历史数据查询，可根据设定值进行数据报警等提示，还可点开信息查询此电机标牌数据，一对一建立电机的电子标牌数据。</p>
                        <p><img src="../images/news/dianjiyun4.png" alt=""/></p>
                        <p><img src="../images/news/dianjiyun5.png" alt=""/></p>
                        <p style="text-align: left;line-height: 60px;">运维检修：根据设定检修周期及检修内容，进行电机检修保养提醒，合理维护保养能延长电机使用寿命，提高电机运行效率，降低维护成本。</p>
                        <p><img src="../images/news/dianjiyun6.png" alt=""/></p>
                        <p><img src="../images/news/dianjiyun7.png" alt=""/></p>
                        <p style="text-align: left;line-height: 60px;">电机租赁：根据合同里面的租赁内容，清晰便捷续费延期等相关提醒功能。</p>
                        <p><img src="../images/news/dianjiyun8.png" alt=""/></p>
					</div>
				</div>

				<div class="news_link">
<!--					<a class="prev" href=""><i class="el-icon-arrow-left"></i>上一条</a>-->
					<a class="menu" href="/news"><i class="el-icon-s-grid"></i>返回列表</a>
<!--					<a class="next" href=""><i class="el-icon-arrow-right"></i>下一条</a>-->
				</div>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
import Header from '../components/hearder.vue'
import Footer from '../components/footer.vue'
export default {
components: {
	Header,
	Footer
},
}
</script>

<style lang="less" scoped>
.news_detail{
	width: 100%;
	margin-top: 60px;

	.title{
		width: 100%;
		border-bottom: 1px solid #ececec;
		padding-bottom: 30px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;

		strong{
			color: #000;
			font-size: 38px;
		}
		span{
			color: #666;
			font-size: 16px;
			margin-top: 20px;
		}
	}
	.text{
		font-size: 16px;
		width: 100%;
		line-height: 32px;
		margin-top: 40px;

		img{
			max-width: 100%;
		}
	}
}
.news_link{
	font-size: 16px;
	width: 100%;
	height: 60px;
	background: #f9f9f9;
	border-radius: 5px;
	padding:0 30px;
	margin-top: 50px;
	display: flex;
	justify-content: space-between;
	align-items: center;

	a{
		color: #666;

		i{
			color: #666;
			margin-right: 5px;
		}
	}
}
</style>